<div #dropdown class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="alertsDropdown">
    <h6 class="dropdown-header">
        {{isDefault ? ('common.default.season' | translate) : ('entity.season.name' | translate)}}
    </h6>
    <form [formGroup]="form" autocomplete="off" onkeydown="return event.key != 'Enter';">
        <!-- <div class="input-group"> -->
            <input type="text" required #seasonCode 
                formControlName="seasonCode" class="form-control" list="seasonCodeDataList"
                appInputList
                placeholder="{{'Temporada' | translate}}" data-size="3" autocomplete="off"
                (keydown.space)="$event.preventDefault();"
                (change)="changeSeason($event.target.value)"
                appUpperCase
            />
            <app-coordinated-season-data-list appId="seasonCodeDataList" appShowName="true"></app-coordinated-season-data-list>
            <!-- <div class="input-group-prepend">
                <button type="submit" class="btn btn-primary btn-sm btn-input-group input-group-text" title="Ok" tabindex="-1" [disabled]="!form.valid">
                    <i class="fas fa-arrow-right"></i>
                </button>
            </div>
        </div> -->
        <!-- <app-form-error [form]="form" controlName="airportIataCodeDataList" [notExists]="true" [required]="true" format="aaa"></app-form-error> -->
    </form>
</div>
